import { render, staticRenderFns } from "./DeveloperLogo.vue?vue&type=template&id=0de34dba&scoped=true&"
import script from "./DeveloperLogo.vue?vue&type=script&lang=ts&"
export * from "./DeveloperLogo.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperLogo.vue?vue&type=style&index=0&id=0de34dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de34dba",
  null
  
)

export default component.exports